import script from "./render-slot.vue?vue&type=script&lang=ts"
export * from "./render-slot.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./render-slot.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__